import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Project, UpdateProjectRequest } from '@seo/types';
import { apiPatch } from '@/lib/api';

export function useUpdateProject(projectId: string | undefined) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateProjectRequest) =>
      apiPatch<Project>(`/v1/projects/${projectId}`, input),
    onSuccess: (updated) => {
      qc.setQueryData(['project', projectId], updated);
      void qc.invalidateQueries({ queryKey: ['projects'] });
    },
  });
}
